// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9a1baf1b","488":"5dc00adb"}[chunkId] + ".chunk.js";
};